import { WSInfoBox } from "@wingspanhq/fe-component-library";
import React from "react";

export const MISCDescription: React.FC = () => (
  <WSInfoBox title="1099-MISC (Box 6)">
    At the moment we only support 1099-MISC Box 6 (Medical and Health Care
    Payments). Box 6 reports medical and health care payments of $600 or more
    made in the course of trade or business to physicians and other healthcare
    providers.
  </WSInfoBox>
);
